export default __webpack_public_path__ + "static/media/addIcon.c2ce9856.svg";